import { render, staticRenderFns } from "./TableMedia.vue?vue&type=template&id=0792b8bf&scoped=true&"
import script from "./TableMedia.vue?vue&type=script&lang=ts&"
export * from "./TableMedia.vue?vue&type=script&lang=ts&"
import style0 from "./TableMedia.vue?vue&type=style&index=0&id=0792b8bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0792b8bf",
  null
  
)

export default component.exports